import React from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { UploadManualOrders } from "./UploadManualOrders";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Link } from "react-router-dom";
import { showNotificationDialogEmergencyOrder } from "redux/actions/notificationEmergencyOrderActions";
import { postFileAccess, showErrorMessageByCode } from "services/commonServices";
import { SOMS_API_KEY } from "services/CONSTANTS";
import { useDispatch } from "react-redux";

import CutOffTimeAlert from "components/common/cutOffTimeAlert";
import { CUTOFF_ACTION } from "components/common/CONSTANTS";
import { CreateManualScreen } from "./CreateManualScreen";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, pl: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

export const CreateOrders = () => {
  const [value, setValue] = React.useState(0);
  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const downloadTemplate = () => {
    const request = {
      apikey: SOMS_API_KEY,
      params: {
        fileName: 'manualOrderTemplate.csv',
        reportType: 'template'
      }
    }

    postFileAccess(request).then(response => {
      const url = response.fileURL
      const fileDownloadTag = document.createElement('a')
      fileDownloadTag.href = url
      fileDownloadTag.click();
    }).catch(err => {
      const { errTitle, errContent } = showErrorMessageByCode(err)
      dispatch(
        showNotificationDialogEmergencyOrder(errTitle, errContent, 'Done')
      );
    });
  }
  return (
    <>
      <div className='mainPageStyling'>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography component="h1" variant="h5" sx={{ mb: 2, mr: 2 }}>
            Create/Upload Manual Orders
          </Typography>
          <CutOffTimeAlert actionType={CUTOFF_ACTION.create_manual_order} />
        </div>
        <Box sx={{ width: "100%", mt: 0.5, pl: 0 }} className="tabStyling">
          <Box
            sx={{ borderBottom: 2, borderColor: "primary", height: "1.76rem" }}
          >
            <Tabs
              className="tabPanelStyling"
              value={value}
              onChange={handleChange}
              aria-label="customer demand tabs"
              textColor="primary.contrastText"
              sx={{
                minHeight: "1rem",
                "& button": {
                  backgroundColor: "secondary.light",
                  fontWeight: "bold",
                  width: "10vw",
                  minHeight: "1.6rem",
                  p: ".3em 0",
                  fontSize: "0.7rem",
                },

                "& .Mui-selected": {
                  backgroundColor: "primary.main",
                  color: "white",
                },
              }}
            >
              <Tab label="Create" {...a11yProps(0)} />
              <Tab label="Upload" {...a11yProps(1)} />
              {value === 1 && <><div className="downloadLink"> <FileDownloadOutlinedIcon onClick={downloadTemplate} style={{ height: '18px', color: "#108810", cursor: "pointer", position: "relative", top: "5px" }} />
                <span><Typography><Link style={{ color: "#108810", cursor: "pointer", fontSize: '11px' }} onClick={downloadTemplate}>Download Template</Link></Typography></span></div></>}
            </Tabs>
          </Box>

          <TabPanel value={value} index={0} component="div">
            <CreateManualScreen />
          </TabPanel>
          <TabPanel value={value} index={1} component="div" className='uploadManualStyling'>
            <UploadManualOrders />
          </TabPanel>
        </Box>
      </div>
    </>
  );
};
